import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';

import {
    buildCheckoutCancelUrl,
    buildCheckoutSuccessUrl,
    createCheckoutSessionOptions,
} from '@/entities/subscription';
import { usePageRestore } from '@/shared/lib/use-page-restore';

export function useStartCheckout() {
    const [pendingPlanCode, setPendingPlanCode] = useState<string | null>(null);
    const checkout = useMutation(createCheckoutSessionOptions());

    // `pendingPlanCode` survives success to cover the gap between the response and the
    // redirect actually leaving the page, so coming back has to clear it explicitly.
    usePageRestore(() => {
        checkout.reset();
        setPendingPlanCode(null);
    });

    const selectPlan = (planCode: string) => {
        if (checkout.isPending) return;

        setPendingPlanCode(planCode);
        checkout.mutate(
            {
                planCode,
                successUrl: buildCheckoutSuccessUrl(),
                cancelUrl: buildCheckoutCancelUrl(),
            },
            {
                onError: () => setPendingPlanCode(null),
            },
        );
    };

    return { selectPlan, pendingPlanCode };
}
